import {combineReducers} from 'redux'
import storage from 'redux-persist/lib/storage'
import {persistReducer} from 'redux-persist'

import Auth from './auth'
import Configs from './configs'

const persistAuth = {
  key: 'Auth',
  storage,
}

const persistConfigs = {
  key: 'Configs',
  storage,
}

const persistedAuth = persistReducer(persistAuth, Auth)
const persistedConfigs = persistReducer(persistConfigs, Configs)

const AllReducers = combineReducers({
  auth: persistedAuth,
  configs: persistedConfigs,
})

export default AllReducers
